import AbstractApiRepository from '~/base/api/AbstractApiRepository';
import { IAxiosResponse } from '~/base/api/axios/IAxiosInterfaces';

import CreateMessageDto from './dto/CreateMessageDto';
import DeleteMessageDto from './dto/DeleteMessageDto';

export default class MessagesApiRepository extends AbstractApiRepository {
  getList = (params: URLSearchParams) => {
    return this.apiClient.get<IAxiosResponse<[]>>({
      url: '/Messages/GetMessagesList',
      config: { params },
    });
  };

  createMessage = (dto: CreateMessageDto) => {
    return this.apiClient.post<IAxiosResponse<[]>>({
      url: `/Messages/SendMessage`,
      data: dto,
    });
  };

  deleteMessage = (data: DeleteMessageDto) => {
    return this.apiClient.delete<IAxiosResponse<[]>>({
      url: '/Messages/DeleteMessage',
      config: {
        data,
      },
    });
  };
}
